import React from 'react'
import styles from './styles.module.scss'

/**
 * Could expand
 * Use for modules: Profile, User, Voucher, etc.
 *
 * The same component as on Workspace
 */

// TODO: add InfoTooltip to the Title
// TODO: reuse on Client/Profile form
export const ListItem = ({ children = null, title = '', value = null }) => (
    <div className={styles.ListItem}>
        {title && <span className={styles.title}>{title}</span>}
        {value && <span className={styles.value}>{value}</span>}
        {children}
    </div>
)
